import { useCallback, useRef } from 'react'
import { Vector2 } from 'three'
import useCanvasEvent from './useCanvasEvent'

const useMouseMovedSinceMouseDown = () => {
  const savedMouseDownPosition = useRef<Vector2>(new Vector2())
  const handleMouseDown = useCallback((event: HTMLElementEventMap['mousedown']) => {
    savedMouseDownPosition.current = new Vector2(event.clientX, event.clientY)
    mouseMoved.current = false
  }, [])
  useCanvasEvent('mousedown', handleMouseDown)

  const handleMouseMove = useCallback((event: HTMLElementEventMap['mousemove']) => {
    mouseMoved.current =
      savedMouseDownPosition.current.distanceTo(new Vector2(event.clientX, event.clientY)) > 10
  }, [])
  useCanvasEvent('mousemove', handleMouseMove)

  const mouseMoved = useRef(false)

  return {
    mouseMoved,
  }
}

export default useMouseMovedSinceMouseDown
